<template>
  <div>
    <slot name="activity-icon"></slot>
    <transition name="slide">
      <div v-if="isActiveComponent" class="activity is-pulled-right">
        <aside>
          <div class="card">
            <header class="card-header has-background-grey-lighter">
              <label class="card-header-title has-text-black-bis" 
                >History</label
              >
              <div class="is-divider-vertical"></div>
              <span
                class="card-header-icon"
                aria-label="more options"
                @click="closeActivity"
              >
                <i class="icon-close"></i>
              </span>
            </header>

            <div class="card-content">
              <p class="control has-icons-left has-icons-right mb-4">
                <input
                  class="input"
                  type="text"
                  placeholder="Search"
                  v-model="searchText"
                  @input="loadData"
                />
                <span class="icon is-small is-left">
                  <i class="icon-search"></i>
                </span>
                <span class="icon is-small is-right"  
                  @click="() => {searchText = ''; loadData()}">
                  <i class="icon-close is-clickable"></i>
                </span>
              </p>
              <div class="sub-content">
                <div
                  v-for="(activity, index) in display.activities" :key="index"
                >
                  <span v-if="showEmptyMsg">
                    No Activity to display!
                  </span>
                  <activity-list v-else class="activity-content"
                    :activity="activity"
                    :showFirst="!index"
                    :idx="index"
                  ></activity-list>
                </div>
                <div class="button" @click="loadMore()" v-if="hideShowMore">
                  Show More
                </div>
              </div>
            </div>
          </div>
        </aside>
      </div>

    </transition>
  </div>
</template>

<script>

import { debounce, isEmpty } from 'lodash';
import { computed, defineComponent, reactive, toRefs } from 'vue';
import CustomFields from '../models/CustomFields';
import ActivityList from '../views/ActivityList.vue';


export default defineComponent({
  name: 'ActivitySlider',
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
  },
  components: {
    ActivityList,
  },
  setup(props, { emit }) {
    const state = reactive({
      showEmptyMsg: false,
      display: {
        activities: [],
      },
      page: 1,
      limit: 10,
      hideShowMore: false,
      searchText: '',
    });

    const loadMore = async () => {
      state.page += 1;
      await loadData();
    }

    const loadData = debounce(async () => {
      state.hideShowMore = false;
      const params = { type: props.type, limit: state.limit, page: state.page }
      if (!isEmpty(state.searchText)) {
        params.search = state.searchText;
      }
      const response = await CustomFields.getCustomFieldActivity(params);
      if (response.data.length) {
        if (state.page === 1) {
          state.display.activities = response.data;
        } else {
          state.display.activities.push(...response.data);
        }
        state.showEmptyMsg = false;
        state.hideShowMore = response.totalCount > state.display.activities.length;
      } else {
        state.hideShowMore = false;
        state.showEmptyMsg = true;
        state.display.activities = [];
      }
      return state.display.activities;
    }, 500, { leading: false, trailing: true })

    const closeActivity = () => {
      state.searchText = ''
      isActiveComponent.value = false;
    }

    const isActiveComponent = computed({
      get: () => {
        if (props.isActive) {
          loadData();
        }
        return props.isActive;
      },
      set: (val) => emit('update:isActive', val),
    });

    return {
      ...toRefs(state),
      closeActivity,
      isActiveComponent,
      loadData,
      loadMore,
    };
  },
})


</script>